<script>
import BuyNow from './buy-now.vue';
import Edit from './edit.vue';
import EditDelta from './edit-delta.vue';
import Add from './add.vue';
import Trial2Paid from './trial2paid.vue';
import planPropsMixin from '@/plans/mx/plan-props';
import planCommonMixin from '@/plans/LARGE_MEETING/mixin';
import { mapGetters } from 'vuex';
import canAutoAdd from '@/components/capacity/mx/canAutoAdd';

export default {
  mixins: [planPropsMixin, canAutoAdd, planCommonMixin],
  computed: {
    ...mapGetters(['getSelectedPlans']),
    selectedPlanList() {
      return this.getSelectedPlans;
    },
  },
  render() {
    if (this.$context.is.add2cart) return <Add on={this.$listeners} />;
    if (this.$context.is.edit) {
      if (this.$context.is.addQty && this.mx_canAutoAdd) {
        return <EditDelta on={this.$listeners} />;
      } else {
        return <Edit on={this.$listeners} />;
      }
    }
    if (this.$context.is.buyNow || this.$context.is.basic2pro || this.$context.is.biz2pro || this.$context.is.downgrade) return <BuyNow {...{ props: { ...this.$props }}} on={this.$listeners} />;
    if (this.$context.is.trial2paid) return <Trial2Paid {...{ props: { ...this.$props }}} on={this.$listeners} />
    return null;
  },
};
</script>
